import React from 'react'
import { Paper, Box, Typography, Chip, IconButton, Stack, TextField, Button } from '@mui/material'
import { Add as AddIcon, Delete as DeleteIcon } from '@mui/icons-material'
import ImageIcon from '@mui/icons-material/Image'

const ShirtSection = ({
  shirts,
  slugShirt,
  typeShirt,
  imageShirt,
  onSlugChange,
  onTypeChange,
  onImageChange,
  onAdd,
  onRemove,
}) => {
  return (
    <>
      {/* Existing Shirts */}
      {shirts &&
        shirts.length > 0 &&
        shirts.map((shirt, index) => (
          <Paper
            key={shirt.id || `shirt-${index}-${Date.now()}`}
            elevation={0}
            sx={{
              p: { xs: 1.5, sm: 2, md: 2.5 },
              mb: { xs: 1.5, sm: 2, md: 2.5 },
              backgroundColor: 'background.paper',
              border: (theme) =>
                `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.08)' : 'rgba(255, 255, 255, 0.12)'}`,
              borderRadius: { xs: 1, sm: 1.25, md: 1.5 },
              boxShadow: (theme) =>
                theme.palette.mode === 'light'
                  ? '0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1)'
                  : '0 1px 3px rgba(0, 0, 0, 0.3), 0 1px 2px rgba(0, 0, 0, 0.4)',
            }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: { xs: 1.5, sm: 2, md: 2.5 },
              }}>
              <Box>
                <Typography
                  variant="h6"
                  component="h2"
                  sx={{
                    fontWeight: 600,
                    mb: { xs: 0.25, sm: 0.375, md: 0.5 },
                    color: 'text.primary',
                    fontSize: { xs: '0.9375rem', sm: '1rem', md: '1.125rem' },
                    lineHeight: 1.3,
                  }}>
                  Shirt {index + 1}
                </Typography>
                <Chip
                  label="Added"
                  color="success"
                  size="small"
                  sx={{
                    fontSize: {
                      xs: '0.625rem',
                      sm: '0.6875rem',
                      md: '0.75rem',
                    },
                    height: { xs: 16, sm: 18, md: 20 },
                  }}
                />
              </Box>
              <IconButton
                onClick={() => onRemove(index)}
                size="small"
                sx={{
                  color: 'error.main',
                  backgroundColor: (theme) =>
                    theme.palette.mode === 'light'
                      ? 'rgba(244, 67, 54, 0.1)'
                      : 'rgba(244, 67, 54, 0.2)',
                  '&:hover': {
                    backgroundColor: (theme) =>
                      theme.palette.mode === 'light'
                        ? 'rgba(244, 67, 54, 0.15)'
                        : 'rgba(244, 67, 54, 0.3)',
                  },
                  width: { xs: 28, sm: 32, md: 36 },
                  height: { xs: 28, sm: 32, md: 36 },
                }}>
                <DeleteIcon
                  sx={{
                    fontSize: { xs: '0.9375rem', sm: '1rem', md: '1.125rem' },
                  }}
                />
              </IconButton>
            </Box>
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={{ xs: 1.5, sm: 2, md: 2.5 }}
              sx={{ width: '100%' }}>
              <TextField
                label="Slug Shirt"
                value={shirt.slug}
                fullWidth
                size="small"
                InputProps={{
                  readOnly: true,
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    fontSize: {
                      xs: '0.8125rem',
                      sm: '0.875rem',
                      md: '0.9375rem',
                    },
                    borderRadius: { xs: 0.75, sm: 1, md: 1.25 },
                    backgroundColor: (theme) =>
                      theme.palette.mode === 'light'
                        ? 'rgba(0, 0, 0, 0.02)'
                        : 'rgba(255, 255, 255, 0.03)',
                  },
                  '& .MuiInputLabel-root': {
                    fontSize: {
                      xs: '0.8125rem',
                      sm: '0.875rem',
                      md: '0.9375rem',
                    },
                    fontWeight: 500,
                  },
                }}
              />
              <TextField
                label="Shirt Type"
                value={shirt.type}
                fullWidth
                size="small"
                InputProps={{
                  readOnly: true,
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    fontSize: {
                      xs: '0.8125rem',
                      sm: '0.875rem',
                      md: '0.9375rem',
                    },
                    borderRadius: { xs: 0.75, sm: 1, md: 1.25 },
                    backgroundColor: (theme) =>
                      theme.palette.mode === 'light'
                        ? 'rgba(0, 0, 0, 0.02)'
                        : 'rgba(255, 255, 255, 0.03)',
                  },
                  '& .MuiInputLabel-root': {
                    fontSize: {
                      xs: '0.8125rem',
                      sm: '0.875rem',
                      md: '0.9375rem',
                    },
                    fontWeight: 500,
                  },
                }}
              />
              <TextField
                label="Shirt Image"
                value={shirt.image}
                fullWidth
                size="small"
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <ImageIcon
                      sx={{
                        color: 'text.secondary',
                        fontSize: {
                          xs: '0.9375rem',
                          sm: '1rem',
                          md: '1.0625rem',
                        },
                        mr: 1,
                      }}
                    />
                  ),
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    fontSize: {
                      xs: '0.8125rem',
                      sm: '0.875rem',
                      md: '0.9375rem',
                    },
                    borderRadius: { xs: 0.75, sm: 1, md: 1.25 },
                    backgroundColor: (theme) =>
                      theme.palette.mode === 'light'
                        ? 'rgba(0, 0, 0, 0.02)'
                        : 'rgba(255, 255, 255, 0.03)',
                  },
                  '& .MuiInputLabel-root': {
                    fontSize: {
                      xs: '0.8125rem',
                      sm: '0.875rem',
                      md: '0.9375rem',
                    },
                    fontWeight: 500,
                  },
                }}
              />
            </Stack>
          </Paper>
        ))}

      {/* Shirt Detail Entry Section */}
      <Paper
        elevation={0}
        sx={{
          p: { xs: 1.5, sm: 2, md: 2.5 },
          mb: { xs: 1.5, sm: 2, md: 2.5 },
          backgroundColor: 'background.paper',
          border: (theme) =>
            `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.08)' : 'rgba(255, 255, 255, 0.12)'}`,
          borderRadius: { xs: 1, sm: 1.25, md: 1.5 },
          boxShadow: (theme) =>
            theme.palette.mode === 'light'
              ? '0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1)'
              : '0 1px 3px rgba(0, 0, 0, 0.3), 0 1px 2px rgba(0, 0, 0, 0.4)',
          transition: (theme) =>
            theme.transitions.create(['box-shadow', 'border-color'], {
              duration: theme.transitions.duration.short,
            }),
          '&:hover': {
            boxShadow: (theme) =>
              theme.palette.mode === 'light'
                ? '0 2px 6px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.12)'
                : '0 2px 6px rgba(0, 0, 0, 0.4), 0 1px 2px rgba(0, 0, 0, 0.5)',
          },
        }}>
        <Box sx={{ mb: { xs: 1.5, sm: 2, md: 2.5 } }}>
          <Typography
            variant="h6"
            component="h2"
            sx={{
              fontWeight: 600,
              mb: { xs: 0.25, sm: 0.375, md: 0.5 },
              color: 'text.primary',
              fontSize: { xs: '0.9375rem', sm: '1rem', md: '1.125rem' },
              lineHeight: 1.3,
              letterSpacing: '-0.01em',
            }}>
            Shirt Detail Entry
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: 'text.secondary',
              fontSize: { xs: '0.6875rem', sm: '0.75rem', md: '0.8125rem' },
            }}>
            Add shirt details for your event
          </Typography>
        </Box>

        <Stack spacing={{ xs: 1.5, sm: 2, md: 2.5 }}>
          <TextField
            label="Slug Shirt"
            placeholder="Enter shirt slug"
            value={slugShirt}
            onChange={onSlugChange}
            fullWidth
            size="small"
            sx={{
              '& .MuiOutlinedInput-root': {
                fontSize: { xs: '0.8125rem', sm: '0.875rem', md: '0.9375rem' },
                borderRadius: { xs: 0.75, sm: 1, md: 1.25 },
                backgroundColor: (theme) =>
                  theme.palette.mode === 'light'
                    ? 'rgba(0, 0, 0, 0.02)'
                    : 'rgba(255, 255, 255, 0.05)',
                transition: (theme) =>
                  theme.transitions.create(['background-color', 'box-shadow'], {
                    duration: theme.transitions.duration.short,
                  }),
                '&:hover': {
                  backgroundColor: (theme) =>
                    theme.palette.mode === 'light'
                      ? 'rgba(0, 0, 0, 0.04)'
                      : 'rgba(255, 255, 255, 0.08)',
                },
                '&.Mui-focused': {
                  backgroundColor: (theme) =>
                    theme.palette.mode === 'light'
                      ? 'rgba(0, 0, 0, 0.04)'
                      : 'rgba(255, 255, 255, 0.08)',
                  boxShadow: (theme) =>
                    theme.palette.mode === 'light'
                      ? '0 0 0 2px rgba(52, 103, 246, 0.1)'
                      : '0 0 0 2px rgba(144, 202, 249, 0.15)',
                },
              },
              '& .MuiInputLabel-root': {
                fontSize: { xs: '0.8125rem', sm: '0.875rem', md: '0.9375rem' },
                fontWeight: 500,
              },
            }}
          />
          <TextField
            label="Shirt Type"
            placeholder="Enter shirt type"
            value={typeShirt}
            onChange={onTypeChange}
            fullWidth
            size="small"
            sx={{
              '& .MuiOutlinedInput-root': {
                fontSize: { xs: '0.8125rem', sm: '0.875rem', md: '0.9375rem' },
                borderRadius: { xs: 0.75, sm: 1, md: 1.25 },
                backgroundColor: (theme) =>
                  theme.palette.mode === 'light'
                    ? 'rgba(0, 0, 0, 0.02)'
                    : 'rgba(255, 255, 255, 0.05)',
                transition: (theme) =>
                  theme.transitions.create(['background-color', 'box-shadow'], {
                    duration: theme.transitions.duration.short,
                  }),
                '&:hover': {
                  backgroundColor: (theme) =>
                    theme.palette.mode === 'light'
                      ? 'rgba(0, 0, 0, 0.04)'
                      : 'rgba(255, 255, 255, 0.08)',
                },
                '&.Mui-focused': {
                  backgroundColor: (theme) =>
                    theme.palette.mode === 'light'
                      ? 'rgba(0, 0, 0, 0.04)'
                      : 'rgba(255, 255, 255, 0.08)',
                  boxShadow: (theme) =>
                    theme.palette.mode === 'light'
                      ? '0 0 0 2px rgba(52, 103, 246, 0.1)'
                      : '0 0 0 2px rgba(144, 202, 249, 0.15)',
                },
              },
              '& .MuiInputLabel-root': {
                fontSize: { xs: '0.8125rem', sm: '0.875rem', md: '0.9375rem' },
                fontWeight: 500,
              },
            }}
          />
          <TextField
            label="Shirt Image"
            placeholder="Enter image URL"
            value={imageShirt}
            onChange={onImageChange}
            fullWidth
            size="small"
            InputProps={{
              startAdornment: (
                <ImageIcon
                  sx={{
                    color: 'text.secondary',
                    fontSize: { xs: '0.9375rem', sm: '1rem', md: '1.0625rem' },
                    mr: 1,
                  }}
                />
              ),
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                fontSize: { xs: '0.8125rem', sm: '0.875rem', md: '0.9375rem' },
                borderRadius: { xs: 0.75, sm: 1, md: 1.25 },
                backgroundColor: (theme) =>
                  theme.palette.mode === 'light'
                    ? 'rgba(0, 0, 0, 0.02)'
                    : 'rgba(255, 255, 255, 0.05)',
                transition: (theme) =>
                  theme.transitions.create(['background-color', 'box-shadow'], {
                    duration: theme.transitions.duration.short,
                  }),
                '&:hover': {
                  backgroundColor: (theme) =>
                    theme.palette.mode === 'light'
                      ? 'rgba(0, 0, 0, 0.04)'
                      : 'rgba(255, 255, 255, 0.08)',
                },
                '&.Mui-focused': {
                  backgroundColor: (theme) =>
                    theme.palette.mode === 'light'
                      ? 'rgba(0, 0, 0, 0.04)'
                      : 'rgba(255, 255, 255, 0.08)',
                  boxShadow: (theme) =>
                    theme.palette.mode === 'light'
                      ? '0 0 0 2px rgba(52, 103, 246, 0.1)'
                      : '0 0 0 2px rgba(144, 202, 249, 0.15)',
                },
              },
              '& .MuiInputLabel-root': {
                fontSize: { xs: '0.8125rem', sm: '0.875rem', md: '0.9375rem' },
                fontWeight: 500,
              },
            }}
          />
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={onAdd}
            fullWidth
            size="small"
            sx={{
              backgroundColor: 'primary.main',
              color: 'white',
              fontWeight: 600,
              fontSize: { xs: '0.8125rem', sm: '0.875rem', md: '0.9375rem' },
              textTransform: 'none',
              py: { xs: 0.875, sm: 1, md: 1.25 },
              borderRadius: { xs: 0.75, sm: 1, md: 1.25 },
              boxShadow: (theme) =>
                theme.palette.mode === 'light'
                  ? '0 2px 6px rgba(52, 103, 246, 0.25)'
                  : '0 2px 6px rgba(144, 202, 249, 0.3)',
              transition: (theme) =>
                theme.transitions.create(['background-color', 'box-shadow', 'transform'], {
                  duration: theme.transitions.duration.short,
                }),
              '&:hover': {
                backgroundColor: 'primary.dark',
                boxShadow: (theme) =>
                  theme.palette.mode === 'light'
                    ? '0 3px 10px rgba(52, 103, 246, 0.35)'
                    : '0 3px 10px rgba(144, 202, 249, 0.4)',
                transform: 'translateY(-1px)',
              },
            }}>
            Add Shirt
          </Button>
        </Stack>
      </Paper>
    </>
  )
}

export default ShirtSection
